import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as roomType from '../room-type'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: roomType.RESOURCE.payload.dimension.partialId,
      partialId: roomType.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'TODO',
    isOptional: true,
    name: 'HEGIS Code', // TODO: maybe dimension + subcode?
    partialId: PartialId.Standard.create('hegis'),
    // TODO: maybe make this an enum
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
